import { useEffect, useRef } from 'react';
import pick from 'lodash/pick';
export function useVisualViewport(onViewportUpdate, enabled) {
    var pendingUpdate = useRef(false);
    var supportsVisualViewport = typeof window !== 'undefined' && window.visualViewport;
    useEffect(function () {
        if (supportsVisualViewport && enabled) {
            onViewportUpdate(window.visualViewport);
        }
    }, [onViewportUpdate, supportsVisualViewport, enabled]);
    useEffect(function () {
        if (!supportsVisualViewport || !enabled) {
            return;
        }
        var viewportHandler = function (e) {
            if (pendingUpdate.current) {
                return;
            }
            pendingUpdate.current = true;
            requestAnimationFrame(function () {
                pendingUpdate.current = false;
                // We don't send the object back because in IOS the reference became always equal
                // and then clientcode would not update like they expected
                onViewportUpdate(pick(e.target, [
                    'offsetLeft',
                    'offsetTop',
                    'pageLeft',
                    'pageTop',
                    'width',
                    'height',
                    'scale',
                ]));
            });
        };
        window.visualViewport.addEventListener('scroll', viewportHandler);
        window.visualViewport.addEventListener('resize', viewportHandler);
        return function () {
            if (enabled) {
                window.visualViewport.removeEventListener('scroll', viewportHandler);
                window.visualViewport.removeEventListener('resize', viewportHandler);
            }
        };
    }, [pendingUpdate, onViewportUpdate, supportsVisualViewport, enabled]);
}
//# sourceMappingURL=useVisualViewport.js.map